const ua = window.navigator.userAgent;

/** 宿主是否为IOS设备 */
export const inIos = /(iPhone|iPad|iPod|iOS)/i.test(ua);

/** 宿主是否为安卓设备 */
export const inAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Linux') > -1;

/** 宿主是否在移动端 */
export const inMobile =
  /iphone|ipod|ipad|android|nokia|sony|ericsson|mot|samsung|sgh|lg|philips|panasonic|alcatel|lenovo|cldc|midp|wap|mobile/i.test(
    ua,
  ) || inAndroid;

/**  宿主是否为微信 */
export const inWechat = /MicroMessenger/i.test(ua);

/**  宿主是否为蜻蜓IOS APP */
export const inIosApp = !!(
  window.webkit &&
  window.webkit.messageHandlers &&
  window.webkit.messageHandlers.getDeviceInfo
);
/**  宿主是否为蜻蜓安卓 APP */
export const inAndroidApp = !!(window.QTJsPlayer && window.QTJsPlayer.GetDeviceInfo);
/**  宿主是否为蜻蜓APP */
export const inApp = inIosApp || inAndroidApp;

/**  宿主是否为蜻蜓 ios精选版app */
export const isCarefulIOSApp = ua.includes('com.Qting.QTCity');

/**  宿主是否为蜻蜓 ios主站app */

export const isUnCarefulIOSApp = inIosApp && !isCarefulIOSApp;

/**  宿主环境 */
export const env = {
  inIos,
  inAndroid,
  inMobile,
  inWechat,
  inIosApp,
  inAndroidApp,
  inApp,
  isCarefulIOSApp,
  isUnCarefulIOSApp,
};
